import { render, staticRenderFns } from "./NolaNovelAssociatedNovelListItem.vue?vue&type=template&id=573d392b&scoped=true"
import script from "./NolaNovelAssociatedNovelListItem.vue?vue&type=script&lang=ts"
export * from "./NolaNovelAssociatedNovelListItem.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelAssociatedNovelListItem.vue?vue&type=style&index=0&id=573d392b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573d392b",
  null
  
)

export default component.exports